import { HERITAGE, COMPANY } from "@/lib/site";
import { Gem, Landmark, ShieldCheck } from "lucide-react";

const PRINCIPLES = [
  { icon: Gem, title: "Strategic Ownership", desc: "We hold and grow world-class AI model families as long-term strategic assets." },
  { icon: Landmark, title: "Intelligent Operation", desc: "The enterprise runs on its own intelligence — insight, allocation and strategy, automated." },
  { icon: ShieldCheck, title: "Governed & Aligned", desc: "Every asset is safety-aligned, monitored and governed across all realms." },
];

export default function About() {
  return (
    <section id="heritage" className="relative py-20 lg:py-28 surface-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.25em] text-emerald-400 font-semibold mb-3">Heritage · Since {COMPANY.established}</p>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-emerald-50 uppercase tracking-tight">
            A House Built for the <span className="gold-gradient-text">Age of Intelligence</span>
          </h2>
          <p className="mt-6 text-slate-300 leading-relaxed font-light">
            Founded in {COMPANY.established}, {COMPANY.name} was established to acquire, steward and scale
            frontier artificial intelligence. We operate as a fully automatic AI enterprise — where the
            portfolio itself reasons, forecasts and compounds value across every realm it touches.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {PRINCIPLES.map((p) => (
            <div
              key={p.title}
              data-testid={`principle-${p.title.toLowerCase().replace(/\s/g, "-")}`}
              className="rounded-2xl border border-emerald-900/60 surface-panel p-7 hover-emerald-glow"
            >
              <div className="w-12 h-12 rounded-xl border border-gold/40 bg-gold/5 flex items-center justify-center mb-5">
                <p.icon className="w-5 h-5 text-gold" />
              </div>
              <h3 className="text-lg text-emerald-50 font-semibold mb-2 font-garamond tracking-wide">{p.title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16">
          <div className="relative border-l border-emerald-900/70 ml-3 pl-8 space-y-10">
            {HERITAGE.map((h, i) => (
              <div key={h.year} className="relative animate-fade-up" style={{ animationDelay: `${i * 0.08}s` }} data-testid={`heritage-${h.year}`}>
                <div className="absolute -left-[41px] top-1 w-4 h-4 rounded-full bg-emerald-500 border-4 border-emerald-void emerald-glow" />
                <div className="font-display text-gold text-lg">{h.year}</div>
                <div className="text-emerald-50 font-semibold mt-1">{h.title}</div>
                <p className="text-sm text-slate-400 mt-1 max-w-xl">{h.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
